module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Regular-d5ff9f6824d2c66073618ceab4a5dae7.woff2";